import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const blocks = document.querySelectorAll(
	'.block-testimonial-quote-image .swiper'
);

if (blocks.length > 0) {
	blocks.forEach((slider, index) => {
		const cardCount = parseInt(
			slider?.parentElement?.dataset?.cardCount ?? 4
		);
		const mobileSlidesPerView = 1;
		const tabletSlidesPerView = 2;
		const desktopSlidesPerView = 3;

		if (cardCount <= 2) {
			return;
		}

		const paginationElement =
			slider.parentElement.querySelector('.swiper-pagination');

		slider.parentElement.classList.add(
			`block-testimonials__swiper--${index}`
		);

		const settings = {
			loop: false,
			grabCursor: true,
			spaceBetween: 8,
			slidesPerView: mobileSlidesPerView,
			modules: [A11y, Navigation, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: `.block-testimonials__swiper--${index} .swiper-button-prev`,
				nextEl: `.block-testimonials__swiper--${index} .swiper-button-next`,
			},
			pagination: {
				el: paginationElement,
				clickable: false,
				dynamicBullets: false,
			},

			breakpoints: {
				768: {
					slidesPerView: tabletSlidesPerView,
					spaceBetween: 24,
				},
				1200: {
					slidesPerView: desktopSlidesPerView,
					spaceBetween: 32,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
